import DMSApp from './dms/DMSApp';
import ManufacturingApp from './manufacturing/ManufacturingApp';

export const MODULE_REGISTRY = {
  dms: {
    id: 'dms',
    label: 'Project & Document Management',
    description: 'Track projects, manage documents, collaborate with your team.',
    icon: 'files',
    app: DMSApp,
    defaultRoute: '/dashboard',
  },
  manufacturing: {
    id: 'manufacturing',
    label: 'Manufacturing & Production Tracking',
    description: 'Track parts across production stages, manage POs and shipments.',
    icon: 'factory',
    app: ManufacturingApp,
    defaultRoute: '/manufacturing/dashboard',
  },
};
